import httpUtil from '../utils/httpUtil.js'
import settings from '../manager/settings.js'
import userUtils from '../manager/userUtils.ts'
import EventBus from '../utils/EventBus.js'

var cartListIfo = {}
var selectedIds = settings.getArray('cartSelectedIds')
var cartUserId = 0

/**
 * 查
 */
function getCartList(forceLoadFromCloud, callback) {
  var currentLoginUserId = userUtils.isLogin()
    ? userUtils.getUserInfo().userid
    : 0;
  console.log("getCartList", forceLoadFromCloud)
  if (currentLoginUserId <= 0) {
    if (callback) callback(false, {}, '未登录')
    return
  }
  if (
    !forceLoadFromCloud &&
    typeof cartListIfo.Items !== typeof undefined &&
    currentLoginUserId == cartUserId
  ) {
    if (callback) callback(true, cartListIfo, '获取成功')
    _sendSelectChangeEvent()
  } else {
    httpUtil.link(
      'shoppingcart',
      'GET',
      {},
      true,
      function (success, res, tips) {
        var result = success ? res.data.Content : {}
        // console.log("购物车：", result)
        if (callback) callback(success, result, tips)
        if (success) {
          cartListIfo = result
          EventBus.send(EventBus.names.CART_CHANGE, cartListIfo, true)
          _removeIdsNoExist()
          _sendSelectChangeEvent()
        }
      }
    )
  }
}

/**
 * 剔除不存在的或不可结算的ID
 */
function _removeIdsNoExist() {
  // 取出选中状态
  var currentSelectedIds = selectedIds
  var newSelectedIds = []
  cartListIfo.Items.forEach(function (item, index, attr) {
    if (
      currentSelectedIds.indexOf(item.Id) !== -1 &&
      (typeof item.Warnings == typeof undefined || item.Warnings.length == 0)
    ) {
      newSelectedIds.push(item.Id)
    }
  })
  selectedIds = newSelectedIds
  settings.setArray('cartSelectedIds', selectedIds)
}

/**
 * 增
 */
function addCart(userSelectSpecific, callback) {
  httpUtil.link(
    'addproducttocartfromdetail',
    'POST',
    JSON.stringify(userSelectSpecific),
    true,
    function (success, res, tips) {
      console.log('加购物车', res)
      if (success) {
        // 购物车中自动选中这件商品
        var cartId = res.data.Content
        if (selectedIds.indexOf(cartId) === -1) {
          selectedIds.push(cartId)
        }
      }
      callback(
        success,
        success ? res.data.Content : {},
        success ? '添加成功' : tips
      )
      if (success) {
        getCartList(true)
      }
    }
  )
}

/**
 * 改
 */
function updateQuantity(cartItemId, count, callback) {
  var postData = {
    ShoppingCartItemQuantities: [
      {
        ShoppingCartItemId: cartItemId,
        Quantity: count,
      },
    ],
  }
  httpUtil.link(
    'updateshoppingcart',
    'POST',
    JSON.stringify(postData),
    true,
    function (success, res, tips) {
      console.log(res)
      if (callback !== null) callback(success, res, tips)
      if (success) {
        cartListIfo = res.data.Content
        EventBus.send(EventBus.names.CART_CHANGE, cartListIfo, true)
        _sendSelectChangeEvent()
      }
    }
  )
}

/**
 * 删
 */
function removeCart(cartItemId, callback) {
  var postData = {
    IdsToRemove: [cartItemId],
  }
  httpUtil.link(
    'updateshoppingcart',
    'POST',
    JSON.stringify(postData),
    true,
    function (success, res, tips) {
      if (callback !== null) callback(success, res, tips)
      if (success) {
        cartListIfo = res.data.Content
        EventBus.send(EventBus.names.CART_CHANGE, cartListIfo, true)

        // 选中状态中取消
        var currentSelectedIds = selectedIds
        if (currentSelectedIds.indexOf(cartItemId) !== -1) {
          // 选中 -> 删除
          currentSelectedIds.splice(currentSelectedIds.indexOf(cartItemId), 1)
          selectedIds = currentSelectedIds
          settings.setArray('cartSelectedIds', selectedIds)
          _sendSelectChangeEvent()
        }
      }
    }
  )
}

/**
 * 变更选中状态
 */
function changeSelectState(cartId) {
  // 不可结算的不可选
  var cartItem = cartListIfo.Items.find((item) => {
    return item.Id == cartId
  })
  if (
    typeof cartItem !== typeof undefined &&
    cartItem.Warnings &&
    cartItem.Warnings.length > 0
  ) {
    // 不可结算元素
    return
  }
  var currentSelectedIds = selectedIds
  if (currentSelectedIds.indexOf(cartId) !== -1) {
    // 选中 -> 未选中
    currentSelectedIds.splice(currentSelectedIds.indexOf(cartId), 1)
  } else {
    // 未选中 -> 选中
    currentSelectedIds.push(cartId)
  }
  selectedIds = currentSelectedIds
  settings.setArray('cartSelectedIds', selectedIds)
  _sendSelectChangeEvent()
}

/**
 * 变更全选状态
 */
function setSelectAll(select) {
  var newSelectIds = []
  if (select) {
    cartListIfo.Items.forEach(function (item, index, attr) {
      if (
        typeof item.Warnings == typeof undefined ||
        item.Warnings.length == 0
      ) {
        newSelectIds.push(item.Id)
      }
    })
  }
  selectedIds = newSelectIds
  settings.setArray('cartSelectedIds', selectedIds)
  _sendSelectChangeEvent()
}
function _sendSelectChangeEvent() {
  // 计算选中总价
  // var totalPrice = 0;
  var isSelectedAll = true
  cartListIfo.Items.forEach(function (item, index, attr) {
    if (selectedIds.indexOf(item.Id) !== -1) {
      // totalPrice += item.SubTotal
    } else {
      // 没有选中
      if (!item.Warnings || item.Warnings.length == 0) {
        isSelectedAll = false
      }
    }
  })
  if (selectedIds.length > 0) {
    getCartPrice(selectedIds, function (success, res, tips) {
      if (success) {
        console.log('计算总价', res)
        EventBus.send(EventBus.names.CART_SELECT_STATE_CHANGE, {
          success: true,
          selectedIds: selectedIds,
          isSelectedAll: isSelectedAll,
          totalPrice: {
            SubTotal: res.data.Content.SubTotal,
            Shipping: res.data.Content.Shipping,
            RequiresShipping: res.data.Content.RequiresShipping,
            HideShippingTotal: res.data.Content.HideShippingTotal,
            OrderTotal: res.data.Content.OrderTotal,
          }, //.OrderTotals.SubTotal//Math.round(totalPrice * 100) / 100,
        }, true)
      } else {
        EventBus.send(EventBus.names.CART_SELECT_STATE_CHANGE, {
          success: false,
          error: tips,
        }, true)
      }
    })
  } else {
    EventBus.send(EventBus.names.CART_SELECT_STATE_CHANGE, {
      success: true,
      selectedIds: [],
      isSelectedAll: false,
      totalPrice: {
        SubTotal: '¥0.00',
        Shipping: '¥0.00',
        RequiresShipping: false,
        HideShippingTotal: true,
        OrderTotal: '¥0.00',
      }, //res.data.Content.OrderTotals.SubTotal//Math.round(totalPrice * 100) / 100,
    }, true)
  }
}

/**
 * 算总价
 */
function getCartPrice(idsArray, callback) {
  var postData = idsArray
  httpUtil.link(
    'shoppingcartgetpice',
    'POST',
    JSON.stringify(postData),
    true,
    function (success, res, tips) {
      if (callback !== null) callback(success, res, tips)
    }
  )
}

/**
 * 结算
 */
function checkout(info, addressId, callback) {
  var postData = {
    ShoppingCartItemIds: info.Ids,
    DiscountId: info.couponId,
    RewardPointsToUse: info.RewardPointsToUse,
    ToApplyGiftCardCouponCode: '',
    ToRemoveGiftCardId: 0,
    AddressId: addressId,
  }
  console.log('结算信息：', postData)
  httpUtil.link(
    'checkout',
    'POST',
    JSON.stringify(postData),
    true,
    function (success, res, tips) {
      if (callback !== null) callback(success, res, tips)
    }
  )
}

/**
 * 下单
 */
function placeOrder(info, addressId, callback) {
  var postData = {
    ShoppingCartItemIds: info.Ids,
    OrderNote: info.orderNote,
    DiscountId: info.couponId,
    AddressId: addressId,
    RewardPointsToUse: info.RewardPointsToUse,
  }
  console.log('下单信息：', postData)
  httpUtil.link(
    'orderplace',
    'POST',
    JSON.stringify(postData),
    true,
    function (success, res, tips) {
      if (callback !== null) callback(success, res, tips)
      if (success) {
        getCartList(true)
        EventBus.send(EventBus.names.ORDER_STATE_CHANGE, {}, true)
      }
    }
  )
}

/**
 * 添加收藏
 */
function addFav(productId, callback) {
  httpUtil.link(
    {
      apiName: 'favoriteadd',
      productId: productId,
    },
    'POST',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
      if (success) {
      }
    }
  )
}

/**
 * 刪除收藏
 */
function delFav(productId, callback) {
  httpUtil.link(
    {
      apiName: 'favoritedel',
      productId: productId,
    },
    'POST',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
      if (success) {
      }
    }
  )
}

/**
 * 獲取收藏
 */
function getFav(pageIndex, callback) {
  httpUtil.link(
    {
      apiName: 'getfavorites',
      Page: pageIndex + 1,
      PageSize: 15,
    },
    'GET',
    {},
    true,
    function (success, res, tips) {
      callback(success, res, tips)
      if (success) {
      }
    }
  )
}

const cartMaganer = {
  addCart: addCart,
  removeCart: removeCart,
  updateQuantity: updateQuantity,
  getCartList: getCartList,
  changeSelectState: changeSelectState,
  setSelectAll: setSelectAll,
  checkout: checkout,
  placeOrder: placeOrder,
  addFav: addFav,
  delFav: delFav,
  getFav: getFav,
}

export default cartMaganer